module.exports = __webpack_public_path__ + "static/media/240.e841749b.wav";